/**
 * This type contains address1, unit number and zip code.
 * We are often required to find a property by comparing all these values.
 * We avoid lots of issues by having unit number and zip code be empty string when "falsy".
 */
export default interface IAddress1UnitNoZipCode {
    address1: string;
    unitNumber: string;
    zipCode: string;
}

export function newAddress1UnitNoZipCode(): IAddress1UnitNoZipCode {
    const result: IAddress1UnitNoZipCode = { address1: '', unitNumber: '', zipCode: '' };
    return result;
}
